// extracted by mini-css-extract-plugin
export var active = "_m4-2";
export var recordingDot = "_m4-1";
export var recordingIndicator = "_m4-0";